import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import FullScreen from './FullScreen';
import Profile from './Profile';

/**
 * Minimal HeaderContent:
 * - Keeps only FullScreen + Profile (user menu/login)
 * - Adds a flexible spacer to push them to the right
 */
export default function HeaderContent() {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5} sx={{ width: '100%' }}>
      <Box sx={{ flexGrow: 1 }} />
      <FullScreen />
      <Profile />
    </Stack>
  );
}



//below is original file

//import { useMemo } from 'react';

/// material-ui
//import { Theme } from '@mui/material/styles';
//import useMediaQuery from '@mui/material/useMediaQuery';
//import Box from '@mui/material/Box';

/// project imports
//import Search from './Search';
//import Message from './Message';
//import Profile from './Profile';
//import Localization from './Localization';
//import Notification from './Notification';
//import FullScreen from './FullScreen';
//import Customization from './Customization';
//import MobileSection from './MobileSection';
//import MegaMenuSection from './MegaMenuSection';

//import useConfig from 'hooks/useConfig';
//import { MenuOrientation } from 'config';
//import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

// ==============================|| HEADER - CONTENT ||============================== //

//export default function HeaderContent() {
//  const { menuOrientation } = useConfig();
//
//  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

//  const localization = useMemo(() => <Localization />, []);

//  const megaMenu = useMemo(() => <MegaMenuSection />, []);

//  return (
//    <>
//      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
//      {!downLG && <Search />}
//      {!downLG && megaMenu}
//      {!downLG && localization}
//      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
//
//      <Notification />
//      <Message />
//      {!downLG && <FullScreen />}
//      <Customization />
//      {!downLG && <Profile />}
//      {downLG && <MobileSection />}
//    </>
//  );
//}
